import { Box } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import React from 'react';
import Chart from 'react-apexcharts';
import type {
  SparkRunsChartCoordinate,
  CreditsChartCoordinate,
} from 'types/HistoryChartData';

type UsageChartProps = {
  sparkRunsChartData: SparkRunsChartCoordinate[];
  creditsUsedChartData: CreditsChartCoordinate[];
  timeUnit: string | undefined;
};
function UsageChart({
  sparkRunsChartData,
  creditsUsedChartData,
  timeUnit,
}: UsageChartProps) {
  const cumulativeSparkRunsValues = sparkRunsChartData.reduce<number[]>(
    (acc, curr) => {
      const count = curr.count ? curr.count : 0;

      const roundedToTwoDecimal = Math.round(count * 100) / 100;
      return [...acc, roundedToTwoDecimal];
    },
    []
  );
  const cumulativeCreditsUsed = creditsUsedChartData.reduce<number[]>(
    (acc, curr) => {
      const amount = curr.amount ? curr.amount : 0;

      const roundedToTwoDecimal = Math.round(amount * 100) / 100;
      return [...acc, roundedToTwoDecimal];
    },
    []
  );

  const options: ApexOptions = {
    chart: {
      id: 'usage-bar',
      width: '100%',
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: sparkRunsChartData.map((chartData) => chartData.date),
      type: timeUnit === 'Day' ? 'datetime' : 'category',
    },
    yaxis: [
      {
        title: {
          text: 'Spark Runs',
        },
      },
      {
        opposite: true,
        title: {
          text: 'Credits',
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: ' 80%',
        borderRadius: 2,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      colors: ['#6267AC', '#FF5733'],
      opacity: 1,
    },
    stroke: {
      colors: ['#6267AC', '#FF5733'],
    },
    markers: {
      size: 5,
    },
  };
  const series: ApexAxisChartSeries = [
    {
      name: 'Spark Runs',
      data: cumulativeSparkRunsValues,
      type: 'bar',
      color: '#6267AC',
    },
    {
      name: 'Credits',
      data: cumulativeCreditsUsed,
      color: '#ECEFFE',
      type: 'line',
    },
  ];

  return (
    <Box
      p={2.5}
      component='div'
      sx={{
        background: '#ffffff',
        boxShadow: '0px 4px 23px 0px rgba(0, 0, 0, 0.04)',
        borderRadius: '10px',
      }}
    >
      <Chart options={options} series={series} type='line' height={400} />
    </Box>
  );
}

export default UsageChart;
